<template>
    <div class="positions-filters">
        <div class="d-flex align-items-end">
            <app-form-select-input 
                :options="options"
                label="Supervisor"
                v-model="parentId"
            />        
            <button class="btn btn-primary ml-1" @click="filter"><i class="fa fa-filter"></i></button>
            <button class="btn btn-secondary ml-1" @click="clearFilters"><i class="fa fa-trash"></i></button>
        </div>
    </div>
</template>
<script>
    import FormSelectInput from '../../../UI/Controls/Forms/FormSelectInput.vue';
export default {
    components: {
        appFormSelectInput: FormSelectInput
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        onFilter: {
            type: Function,
            required: true
        },
        onClearFilters: {
            type: Function,
            required: true
        }
    },
    data(){
        return {
            parentId: ''
        }
    },
    methods: {
        filter(){
            this.onFilter({ parent: this.parentId });
        },
        clearFilters(){
            this.onClearFilters();
        }
    }
}
</script>